import { render, staticRenderFns } from "./loginIndex.vue?vue&type=template&id=677d8e5e&scoped=true"
import script from "./loginIndex.vue?vue&type=script&lang=ts"
export * from "./loginIndex.vue?vue&type=script&lang=ts"
import style0 from "./loginIndex.vue?vue&type=style&index=0&id=677d8e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677d8e5e",
  null
  
)

export default component.exports